import { GlobalComposable } from "~/classes/composable/GlobalComposable"
import { mimeTypeString } from "~/classes/entity"

class Onboarding extends GlobalComposable {
  override onCreate = () => {
    // const { addInterfaceEventListener } = useEvents()

    // Enable this if you want to print the current folder
    // contents (during development)
    // addInterfaceEventListener("afterNavigatedToFolder", this.currentFolderToOnboardingJson)
  }

  createOnboardingContentAndMarkAsCompleted = async () => {
    const { userInterfaceSettings, persistUserInterfaceSettings } = useSelf()
    const settings = userInterfaceSettings.value
    if (!settings)
      return console.error("Cannot create onboarding content before login")
    if (settings.onboardingComplete)
      return console.warn("Onboarding already complete, skipping creation")
    if (isDesktop())
      await useTauri().createOnboardingContent()
    else
      await useCache().createOnboardingContent()
    console.debug("Onboarding content created, marking onboarding as complete")
    persistUserInterfaceSettings({ onboardingComplete: true })
  }

  /**
   * To be used during development only. Takes the current
   * state of the folder you are viewing right now, and outputs
   * a json representation that we use to derive the onboarding
   * experience.
   *
   * TODO: fix the fact that notes are not requested in folder view so no file has its notes here.
   */
  currentFolderToOnboardingJson = async () => {
    await sleep(3000) // wait for the page to load, ish.
    const { state: collectionState } = useCollectionView()

    const allFiles: {
      name: string
      mimeType: string
      hash?: string
      size?: number
      notes?: string
      tags?: string[]
      rating?: number
    }[] = []
    for (const file of Object.values(collectionState.value.contents)) {
      let hash
      if (file.checksum())
        hash = Array.from(file.checksum()!).map(b => b.toString(16).padStart(2, "0")).join("")

      allFiles.push({
        name: file.name()!,
        mimeType: mimeTypeString(file.mimeType()!),
        hash,
        size: file.size(),
        notes: file.notes(),
        tags: [...file.tags()],
        rating: file.rating(),
      })
    }
    console.log(JSON.stringify(allFiles, null, 2))
  }
}

const onboarding = new Onboarding("onboarding", theme.colors.pink.hex)
export default function () {
  return onboarding.use()
}
